import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var revamp = config.revamp;
var base = "edis/";
// https://nw.nuvamawealth.com/edelmw-eq/eq/edis/holdings
var EdisConfigURL = {
    edisBase: config.jmw + config.eqedel + base,
    holdings: config.jmw + config.eqedel + base + "holdings",
    history: config.jmw + config.eqedel + base + "auth/history",
    status: config.jmw + config.eqedel + base + "status",
    // https://nw.nuvamawealth.com/edelmw-eq/eq/edis/status
};
export default EdisConfigURL;
